import { constantsData, formFieldNamesData } from "@/data";
import { FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    description,
    name,
} = constantsData.forms.dataSources.categories.category;

const {
    description: descriptionFieldName,
    name: nameFieldName,
} = formFieldNamesData;

export const dataSourceCategoryFormData = [
    {
        description: name.description,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: description.description,
        isOptional: true,
        label: description.label,
        name: descriptionFieldName,
        type: FieldTypeEnum.TEXTAREA,
    },
];
